import { Inject, Injectable } from '@angular/core';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';
import { CommonsSessionStorageService, downgradeToAJSService } from 'ib-web-commons/utils';
import { IbSubscriptionModelsSummaryService } from '../summary/ib-subscription-models-summary.service';
import { initSubscriptionModelsServiceModel } from '@src/app/core/models/summary-service.model';
import { SummaryProps } from 'commercial-management--ancillaries--web-components-design--library';

export type PaymentContextResponse = {data:{contextId:string}};

@Injectable({
    providedIn: 'root'
})
export class IbSubscriptionModelsPaymentsService {

    constructor (
        private commonsSessionStorageService: CommonsSessionStorageService,
        private ibSubscriptionModelsSummaryService: IbSubscriptionModelsSummaryService,
        @Inject('NewMainHeaderFacade') private newMainHeaderFacade: any,
        @Inject('CommonsGenericProxy') private CommonsGenericProxy: any

    ) { }

    async initPaymentForm (): Promise<initSubscriptionModelsServiceModel> {
        this.newMainHeaderFacade.showLogin();
        this.updateSteps(this.commonsSessionStorageService.get('actualStepFlow'));
        const flowId: string = this.commonsSessionStorageService.get('flowId');

        let paymentContextResponse;
        // let paymentContextResponse:string =
        //     this.commonsSessionStorageService.get(subscriptionModelsAppConstant.SESSION_STORAGE.PAYMENT_CONTEXT_RESPONSE);
        if(!paymentContextResponse){
            const response:PaymentContextResponse=
                await this.CommonsGenericProxy.postGeneric(
                    subscriptionModelsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_CONTEXT.replace('{flowId}', flowId),
                    this.getPostData()
                );
            paymentContextResponse = response.data.contextId;
        }
        this.commonsSessionStorageService.set(subscriptionModelsAppConstant.SESSION_STORAGE.PAYMENT_CONTEXT_RESPONSE, paymentContextResponse);

        let summaryResponse: SummaryProps = this.commonsSessionStorageService.get(subscriptionModelsAppConstant.SESSION_STORAGE.SUMMARY) as SummaryProps;
        if(!summaryResponse) {
            summaryResponse = await this.ibSubscriptionModelsSummaryService.getSummary();
        }

        this.commonsSessionStorageService.set(subscriptionModelsAppConstant.SESSION_STORAGE.SUMMARY, summaryResponse);

        return{
            paymentContext: paymentContextResponse,
            summaryProps: summaryResponse
        };

    }

    private getPostData (): any {
        const postData ={
            redirection:{
                success: {
                    url: 'string',
                    data: 'string',
                    method: 'string'
                },
                failure: {
                    url: 'string',
                    data: 'string',
                    method: 'string'}
            }
        };

        return postData;
    }

    private updateSteps (position: string): void {
        this.newMainHeaderFacade.updateStepsModel(position);
    }
}

downgradeToAJSService('IbSubscriptionModelsPaymentsService', IbSubscriptionModelsPaymentsService, 'ib-subscription-models-payments-module');
